import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DxFormComponent } from 'devextreme-angular/ui/form';
import { RouteKeys } from 'src/app/share/helper/route-keys.helper';
import { ApiService } from 'src/app/share/services/api.service';
import { ConfigService } from 'src/app/share/services/config.service';
import { LanguageService } from 'src/app/share/services/language.service';
import { UrlService } from 'src/app/share/services/url.service';

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss'],
    standalone: false
})
export class RegisterComponent implements OnInit {
  @ViewChild('registerForm', { static: false }) registerForm: DxFormComponent;

  msg: string = '';
  messageTimeout: number;

  registerFormData: any = {};
  registerComplete: boolean = false;
  timeStamp: any;
  inProcess: boolean = false;

  constructor(
    private apiService: ApiService,
    private languageService: LanguageService,
    public configService: ConfigService,
    private router: Router,
    private urlService: UrlService
  ) {}

  ngOnInit() {
    this.timeStamp = Date.now();
    this.registerFormData.confirm = false;
  }

  onClickCancel = () => {
    this.onReset();
    this.urlService.naviToPreserveQueryParams('extern/start');
  };

  onClickRegister = () => {
    const validate = this.registerForm.instance.validate();
    this.timeStamp = Date.now() - this.timeStamp;
    this.registerFormData.confirm_2 = btoa('' + this.timeStamp);
    if (validate.isValid) {
      this.inProcess = true;
      this.apiService.post(RouteKeys.Extern.Register.register_account, this.registerFormData).subscribe({
        next: (response) => {
          this.registerComplete = true;
          this.inProcess = false;
        },
        error: (err) => {
          if (err.status === 600) {
            this.msg = err.message;
            this.inProcess = false;
          } else {
            let _err;

            if (err.error || err.Error) {
              const ___err = err.error || err.Error;
              if (___err.message || ___err.Message) {
                _err = ___err.message || ___err.Message;
              } else {
                _err = ___err;
              }
            } else if (err.message || err.Message) {
              _err = err.message || err.Message;
            } else {
              _err = err;
            }
            this.inProcess = false;
            this.setMessageText(_err || this.languageService.translate('laterError'));
            throw _err || this.languageService.translate('serverError');
          }
        },
      });
    }
  };

  onClickToStart = () => {
    this.urlService.naviToPreserveQueryParams('extern/start');
  };

  onReset() {
    this.registerForm.instance.resetValues();
    this.timeStamp = Date.now();
  }

  setMessageText(msg: string) {
    this.msg = msg;
    if (this.messageTimeout > 0) {
      clearTimeout(this.messageTimeout);
    }
    setTimeout(() => {
      this.msg = '';
    }, 7000);
  }
}
